module.exports = __webpack_public_path__ + "img/introducePageTwo_show_nine.5408385f.jpg";